/**
 * Destination après connexion : on saute Accueil quand l'utilisateur
 * n'a qu'un seul espace métier (évite un clic inutile).
 *
 * Accueil reste le sélecteur pour le staff et les clients « private »
 * (analyse patrimoniale + mandat).
 */
import { getUserRole, isClientFacingRole } from '@/utils/auth';
import { getProfileSessionItem } from '@/utils/sessionAuth';

export function hasAccessToBothModules() {
  const role = String(getUserRole() || getProfileSessionItem('user_role') || '')
    .trim()
    .toLowerCase();
  if (
    role === 'admin' ||
    role === 'employe' ||
    role === 'saisie' ||
    role === 'validation' ||
    role === 'conseiller' ||
    role === 'it'
  ) {
    return true;
  }
  if (isClientFacingRole(role) && getProfileSessionItem('type_client') === 'private') {
    return true;
  }
  return false;
}

/** Staff : toujours. Client : uniquement si `type_client === 'private'`. */
export function canAccessMandatModule(role) {
  const r = String(role || getUserRole() || getProfileSessionItem('user_role') || '')
    .trim()
    .toLowerCase();
  if (!isClientFacingRole(r)) return true;
  return getProfileSessionItem('type_client') === 'private';
}

/** Chemin par défaut si aucune query `redirect` n'est fournie. */
export function resolveDefaultPostLoginPath() {
  if (hasAccessToBothModules()) return '/acceuil';
  if (isClientFacingRole()) return '/analyse-patrimoniale';
  return '/acceuil';
}
